import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/login.css";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMessage("Passwords do not match!");
      setIsError(true);
      return;
    }

    try {
      const response = await axios.post(
        `${API}/reset-password/${token}`, { password }
      );
      setMessage(response.data.message);
      setIsError(false);
      setTimeout(() => navigate("/admin/login"), 2000);
    } catch (error) {
      setMessage(error.response?.data?.message || "Server error");
      setIsError(true);
    }
  };

  return (
    <div className="login-container">
      <div className="left-section">
        <img src="/assets/logo/inypeople_logo.png" alt="Logo" className="logo" />
        <div className="left-content">
          <h1>New Password</h1>
          <p>Set your new secure password</p>
          <div className="line"></div>
          <img src="/assets/images/login_img.png" alt="Illustration" className="illustration" />
        </div>
      </div>

      <div className="right-section">
        <div className="form-box">
          <h2>Set New Password</h2>
          <p className="sub-text">Enter and confirm your new password</p>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>New Password</label>
              <div className="input-box">
                <span className="icon">
                  <img src="/assets/images/log-pass.png" alt="pass" className="input-icon" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span className="eye"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: "pointer" }}>
                  <img
                    src={showPassword ? "/assets/images/Eye_Open.png" : "/assets/images/log-eye.png"}
                    alt="eye" className="eye-icon"
                  />
                </span>
              </div>
            </div>

            <div className="input-group">
              <label>Confirm Password</label>
              <div className="input-box">
                <span className="icon">
                  <img src="/assets/images/log-pass.png" alt="pass" className="input-icon" />
                </span>
                <input
                  type="password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className="signin-btn">
              Reset Password
            </button>
          </form>

          {message && (
            <p className="login-message"
              style={{ color: isError ? "red" : "green", marginTop: "15px" }}>
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;